export default __webpack_public_path__ + "static/media/Macbook-white.6aec4d5a.svg";